import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ipstack = defineConnector({
  identifier: "ipstack",
  name: "ipstack",
  tagLine: "IP geolocation API",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.ipstack\\.com/.*",
  auth: (app) =>
    queryAuth([{ name: "access_key", value: app.secret.accessKey }]),
  steps: [
    {
      title: "Get your API access key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your [ipstack](https://ipstack.com/) account and copy your API access key from the dashboard.",
        },
      ],
    },
    {
      title: "Paste your access key",
      items: [
        {
          kind: "input",
          label: "API access key",
          required: true,
          target: { kind: "secrets", field: "accessKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ipstack.com/check",
  },
});
